var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 4,
    viewBox: "0 0 41 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1768 2.17677C40.2744 2.07914 40.2744 1.92085 40.1768 1.82322L38.5858 0.23223C38.4882 0.134599 38.3299 0.134599 38.2322 0.23223C38.1346 0.329861 38.1346 0.488152 38.2322 0.585783L39.6464 2L38.2322 3.41421C38.1346 3.51184 38.1346 3.67013 38.2322 3.76776C38.3299 3.86539 38.4882 3.86539 38.5858 3.76776L40.1768 2.17677ZM2.18557e-08 2.25L40 2.25L40 1.75L-2.18557e-08 1.75L2.18557e-08 2.25Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRed);
export default __webpack_public_path__ + "static/media/vector-red.c71d59d8e01efdae2ab1ea6c2f14c147.svg";
export { ForwardRef as ReactComponent };